export const manufacturersFreightDetails = {
    calculation_method: 'percentage_of_order',
    percentage_of_order: 20,
    flat_fee: 2000
};
